import React, { useState }  from 'react';
import FilterOverlay        from './filter-overlay';
import { useTranslation } from 'react-i18next';

interface FilterProps {
    onButtonClick: (filter: { [key: string]: boolean; }) => void;
}

const Filter: React.FC<FilterProps> = ({ onButtonClick }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [currentFilter, setCurrentFilter] = useState<{ [key: string]: boolean; }>({});

    const [openClass, setIsOpenClass] = useState(false);

    const { t } = useTranslation();

    const handleClick = () => {
        setIsOpen(!isOpen)
        setIsOpenClass(!isOpen)
    };

    const handleFilterChange = (filter: { [key: string]: boolean; }) => {
        setCurrentFilter(filter);
        onButtonClick(filter);
    };

    const trueFilterCount = Object.values(currentFilter).filter(val => val).length;

    return (
        <div className={`filter-container ${openClass ? 'is-opened' : ''}`}>
            <div className="open-filter">
                <button
                    className="filter-button"
                    onClick={handleClick}
                    role="button"
                    tabIndex={0}
                    aria-disabled={false}
                >
                    {t('Filter')} ({trueFilterCount})
                </button>
            </div>

            <FilterOverlay open={isOpen} handleClick={handleClick} handleFilterChange={handleFilterChange}/>
        </div>
    );
};

export default Filter;
